import { useDispatch, useSelector } from 'react-redux';
import { IconSun, IconMoon, IconDeviceDesktop } from '@u21/tabler-icons';
import {
  U21ButtonGroup,
  U21Divider,
  U21Typography,
} from 'app/shared/u21-ui/components';
import { selectThemePreference } from 'app/modules/theme/selectors';
import { updateThemePreference } from 'app/modules/theme/sliceTheme';
import styled from 'styled-components';
import { ThemePreference } from 'app/modules/theme/models';

export const ThemePreferenceSection = () => {
  const dispatch = useDispatch();
  const preference = useSelector(selectThemePreference);

  return (
    <>
      <U21Divider horizontal />
      <Title color="text.secondary">Theme</Title>
      <U21ButtonGroup<ThemePreference>
        buttons={[
          {
            value: 'system',
            label: 'System',
            startIcon: <IconDeviceDesktop />,
          },
          {
            value: 'light',
            label: 'Light',
            startIcon: <IconSun />,
          },
          {
            value: 'dark',
            label: 'Dark',
            startIcon: <IconMoon />,
          },
        ]}
        onClick={(newPreference) => {
          dispatch(updateThemePreference(newPreference));
        }}
        size="small"
        value={preference}
      />
    </>
  );
};

const Title = styled(U21Typography)`
  margin: 8px;
`;
